import { renewalTransactionsColumns } from "./renewalsColumns";
import { SearchableTable } from "../shared/table/SearchableTable";

const RenewalTransactions = ({ transactions, loading }) => {
  return (
    <>
      <SearchableTable
        keyColumn="DocumentKey"
        dataSource={transactions}
        columns={renewalTransactionsColumns()}
        loading={loading}
        size="small"
        rowKey={(t) => t.DocumentKey}
        hideClearFiltersButtons={true}
        rowClassNameExtended={(record, defaultFunction) => {
          if (
            record.TransactionTypeDesc === "Cancellation" ||
            record.TransactionTypeDesc === "Cancelled"
          ) {
            return "renewal-transaction-cancelled";
          }
          if (record.NextTermRenewal === true || record.NextTermRenewal === 1) {
            return "renewal-transaction-next-term";
          }
          if (record.LinkedToRenewal === true || record.LinkedToRenewal === 1) {
            return "renewal-transaction-linked";
          }
          return defaultFunction(record);
        }}
      />
    </>
  );
};

export default RenewalTransactions;
